import { Content } from "@/ui/Content";
import * as simplePagesAdditionalComponents from "@/components/SimplePage";
import * as popularRolesAdditionalComponents from "@/components/PopularRolesPage";
import * as landingPagesAdditionalComponents from "@/components/LandingPage";
import { getSimplePagesStaticProps } from "@/functions/getSimplePagesStaticProps";
import { getPopularRolesStaticProps } from "@/functions/getPopularRolesStaticProps";
import { getLandingPagesStaticProps } from "@/functions/getLandingPagesStaticProps";
import { pages_helper } from "@/helpers/pages_helper";
import { popular_roles_helper } from "@/helpers/popular_roles_helper";
import { landing_pages_helper } from "@/helpers/landing_pages_helper";

//Page Builder Components
import useDynamicPage from "@/hooks/useDynamicPage";
import { getDynamicPageStaticProps } from "@/functions/getDynamicPageStaticProps";
import { DynamicPageSeo } from "@/ui/DynamicPageSeo";
import { BuilderContentBlocks } from "@/ui/BuilderContentBlocks";
import dynamicPages from "@/../.sourceflow/dynamic_pages.json";

export default function SimpleOrPopularRolesPage({ prefix, title, seo, canonical, data, isBuilder, content }) {
  return isBuilder ? (
    <>
      <DynamicPageSeo
        {...seo}
        title={seo?.title.length > 0 ? seo.title : title}
        canonical={seo?.canonical.length > 0 ? seo.canonical : canonical}
      />
      <BuilderContentBlocks data={data} prefix={prefix} />
    </>
  ) : (
    <Content
      items={content}
      additionalComponents={{
        ...simplePagesAdditionalComponents,
        ...popularRolesAdditionalComponents,
        ...landingPagesAdditionalComponents,
      }}
    />
  );
}

export async function getStaticProps({ params: { url_slugs } }) {
  const url_slug = url_slugs.join("/");
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const builderPage = useDynamicPage(url_slug);
  if (builderPage) {
    return getDynamicPageStaticProps({ page: builderPage, url_slug });
  }

  if (popular_roles_helper.find(url_slug)) {
    return getPopularRolesStaticProps(url_slug);
  }

  if (landing_pages_helper.find(url_slug)) {
    return getLandingPagesStaticProps(url_slug);
  }

  return getSimplePagesStaticProps(url_slugs);
}

export async function getStaticPaths() {
   // adds page builder
   const builderPaths = dynamicPages
   .filter((i) => !["/"].includes(i.url_slug))
   .map((i) => ({ params: { url_slugs: i.url_slug.split("/") } }));

  return {
    paths: [
      ...builderPaths,
      ...pages_helper.toNestedPaths(),
      // These don't use nested in CMS, using this method for template purposes only
      ...popular_roles_helper.toNestedPaths(),
      ...landing_pages_helper.toNestedPaths(),
    ],
    fallback: false,
  };
}
